import type { BaseError as ViemBaseError } from "viem"
import type { BaseError as WagmiBaseError } from "wagmi"
import { walk } from "./walk"

export function isLedgerError(error: WagmiBaseError | ViemBaseError): boolean {
  return !!walk(error, e => {
    const errorMessage = e instanceof Error ? e.message : JSON.stringify(e)

    if (LEDGER_REGEX.test(errorMessage)) {
      return true
    }

    return false
  })
}

const LEDGER_REGEX = /ledger/gi
